/**
 * @Description 搜索
 */

import V2Tabs from '@/common/components/Data/V2Tabs';
import { Form, FormProps } from 'antd';
import styles from '../index.module.less';
import { FC, useEffect, useMemo, useState } from 'react';
import ButtonTabs from '@/common/components/Tabs/ButtonTabs';
import V2Form from '@/common/components/Form/V2Form';
import V2FormCheckbox from '@/common/components/Form/V2FormCheckbox/V2FormCheckbox';
import { useMethods } from '@lhb/hook';
import { surroundPOICategoryList, surroundSharePOICategoryList } from '@/common/api/siteselectionmap';
import { isArray } from '@lhb/func';
import { useBigdataFn } from '@/common/utils/bigdata';
import { useSelector } from 'react-redux';
import { demoForCarModelIds } from '@/views/iterate/pages/siteselectionmapb/ts-config';

// 带搜索和重置按钮的form
export interface SearchFormProps extends FormProps {
  onSearch?: Function; // 确定
  className?: string;
  detail?: any;
  setCurDetail:any;
  setIsNodata?: any; // 是否无一级tab，或各一级tab下的poi数都为0
  setStoreOptions?: any; // 所有展示项
  isShare?: boolean;
  shareParams?: any;
}

const Search: FC<SearchFormProps> = ({
  detail,
  onSearch,
  setCurDetail,
  setIsNodata,
  setStoreOptions,
  isShare,
  shareParams,
}) => {
  const modelConfigId = useSelector((state: any) => state.iterate.modelConfigId); // 存放选址地图页面的当前模型
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [form] = Form.useForm();
  const knownBrandType = 'FAMOUS_BRAND'; // 知名品牌类型值为1
  const competitorType = 'COMPETITION_BRAND'; // 竞品类型为2
  // const otherShowSecondLevelCode = ['01', '02', '08']; // 其他分类下需要显示二级分类的code， 01 是餐饮，02 是购物 08是车辆服务
  // const otherShowSecondLevelCode: any = []; // 不需要额外处理
  const [data, setData] = useState<any>([]);// 原始数据
  const [commercialData, setCommercialData] = useState<any>([]);// 业态
  const [currentCommercialIndex, setCurrentCommercialIndex] = useState<string>('');// 业态key值
  const [secondCommercialData, setSecondCommercialData] = useState<any>([]);// 二级分类
  const [currentSecondCommercialIndex, setCurrentSecondCommercialIndex] = useState<string>('');// 业态key值
  const [ageLimitData, setAgeLimitData] = useState<any>([]); // 年限

  const [filters, setFilters] = useState<any>({
    filrstLevelCode: '', // 除了知名品牌、竞品，其他的类型的code
    secondLevelCode: '', // 二级分类code
    thirdLevelCode: '', // 年限
    name: ''
  });

  const otherShowSecondLevelCode = useMemo(() => {
    if (demoForCarModelIds.includes(modelConfigId)) {
      return ['01', '02'];
    }
    return ['01', '02', '08']; // 其他分类下需要显示二级分类的code， 01 是餐饮，02 是购物 08是车辆服务
  }, []);

  useEffect(() => {
    if (detail?.id) {
      methods.loadData();
    }
  }, [detail]);

  useEffect(() => {
    onSearch?.(filters);
  }, [filters]);

  const methods = useMethods({
    clearForm() {
      form.resetFields();
    },
    onCommercialChange(activeKey: string) { // 一级分类变化
      setCurDetail?.(null);
      setCurrentCommercialIndex(activeKey);
      const filrstLevelCode = activeKey;
      const name = commercialData?.find((item: any) => item.key === activeKey)?.name; // 匹配图例
      let type = '';
      if (knownBrandType === activeKey) {
        type = '1';
      }
      if (competitorType === activeKey) {
        type = '2';
      }
      setFilters({ ...filters, ...{
        type,
        filrstLevelCode: filrstLevelCode,
        secondLevelCode: null,
        thirdLevelCode: null,
        categoryId: null,
        name
      } });
      bigdataFn('fa0e5289-d2f3-4035-a67c-5ca14071de93', '详情-经营门店-点击一级TAB', '点击了详情-经营门店-点击一级TAB', { op_block: '开店区域-详情页', op_event: `${detail?.areaName}-${name}`, });

      setCurrentSecondCommercialIndex('');
      methods.clearForm();
    },
    onSecondCommercialChange(activeKey: string) { // 二级分类变化
      setCurDetail?.(null);
      activeKey = activeKey + '';

      setCurrentSecondCommercialIndex(activeKey);
      const secondTabsName = secondCommercialData?.find((item: any) => item.key === activeKey)?.label; // 匹配图例
      bigdataFn('ccdcb314-53cb-4753-9581-6050037afd74', '详情-经营门店-点击二级TAB', '点击了详情-经营门店-点击二级TAB', { op_block: '开店区域-详情页', op_event: `${detail?.areaName}-${filters?.name}-${secondTabsName}`, });
      if (currentCommercialIndex === knownBrandType) { // 代表是知名品牌
        setFilters({ ...filters, ...{ categoryId: activeKey || null } });
      } else {
        setFilters({ ...filters, ...{
          secondLevelCode: activeKey || null,
          categoryId: null, // 此时categoryId需要置为null
        },
        });
      }
      // 查找此时的一级tab
      const target = commercialData.find((item) => item.key === currentCommercialIndex);
      if (!target) return;
      const { name } = target;
      // 查找对应的源数据
      const targetData = data.find((item) => item.name === name);

      if (!targetData) return;
      // 一层层查对应的children
      const { children } = targetData;
      if (!isArray(children)) return;
      // 全部时，activeKey为空字符串，而且item.code为null
      const targetChild = children.find((item) => item.code === activeKey || (!activeKey && !item.code));
      if (!targetChild) return;
      // 三级children
      const { children: threeLevelChild } = targetChild;

      const targetButtons = threeLevelChild?.map((item: any) => {
        return {
          value: item.code,
          label: item.name + (item.poiNum ? `(${item.poiNum})` : ''),
        };
      });
      // setAgeLimitData(targetButtons);
      setAgeLimitData(targetButtons);
    },
    onAgeLimitChange(activeKey: any) { // 三级分类变化
      setCurDetail?.(null);
      setFilters({ ...filters, ...{ thirdLevelCode: activeKey || null } });
      bigdataFn('26620ad2-4d73-4e96-a04f-a1127b43bcf0', '详情-经营门店-点击经营年限', '点击了详情-经营门店-点击经营年限', { op_block: '开店区域-详情页', op_event: `${detail?.areaName}`, });
    },
    loadData: async () => { // 初始化
      const params: any = {
        // range: 500,
        // latitude: detail?.lat,
        // longitude: detail?.lng
        clusterId: detail.id
      };
      const targetFetch = isShare && (!shareParams?.token) ? surroundSharePOICategoryList : surroundPOICategoryList;
      if (isShare) {
        params.tenantId = shareParams?.tenantId;
        params.userId = shareParams?.employeeId;
      }
      const res: any = await targetFetch(params, false);
      const industries = isArray(res?.industries) ? res.industries.filter((itm: any) => {
        if (demoForCarModelIds.includes(modelConfigId)) {
          return itm;
        }
        return !!itm.poiNum;
      }) : [];
      setData(industries);
      setIsNodata(!industries.length);
      setStoreOptions?.(industries);

      const firstData = industries?.map((item) => {
        return {
          key: item.code,
          label: item.name + (item.poiNum ? ' ' + item.poiNum : ''),
          name: item.name,
        };
      }) || [];
      let type = '';
      if (knownBrandType === firstData[0]?.key) {
        type = '1';
      }
      if (competitorType === firstData[0]?.key) {
        type = '2';
      }
      const filrstLevelCode = industries[0]?.code || null;
      const secondCode = industries[0]?.children?.[0]?.code || null;
      const secondLevelCode = secondCode && secondCode.length === 3 ? null : secondCode;

      // 设置业态
      setCommercialData(firstData);
      firstData[0]?.key && setFilters({ ...filters, ...{ type, name: firstData[0]?.name }, filrstLevelCode, secondLevelCode, thirdLevelCode: null, });
      firstData[0]?.key && setCurrentCommercialIndex(firstData[0].key);

    },
  });

  useEffect(() => {
    if (!currentCommercialIndex) return;
    if (knownBrandType === currentCommercialIndex) { // 如果是知名品牌则
      const secondCommercialDatas = data.find((item) => item.code === currentCommercialIndex && isArray(item.children))?.children?.map(item => {
        return {
          key: `${item.type || ''}`,
          label: item.name + (item.poiNum ? ' ' + item.poiNum : ''),
        };
      });
      const firstData = secondCommercialDatas?.[0];
      setSecondCommercialData(secondCommercialDatas);
      setCurrentSecondCommercialIndex(firstData?.key); // 设置二级选中的位置
      setAgeLimitData([]);
      // const secondTabsName = secondCommercialData?.find((item: any) => item.key === firstData)?.label; // 匹配图例
      // bigdataFn('ccdcb314-53cb-4753-9581-6050037afd74', '详情-经营门店-点击二级TAB', '点击了详情-经营门店-点击二级TAB', { op_block: '开店区域-详情页', op_event: `${filters?.name}-${secondTabsName}`, });
    } else if (competitorType === currentCommercialIndex) { // 如果是竞品
      setSecondCommercialData([]);
      setAgeLimitData([]);
    } else {
      const currentData = data.find((item) => item.code === currentCommercialIndex);
      const filrstLevelCode = currentData?.['code'];
      let checkButtonData = [];

      if (otherShowSecondLevelCode.includes(filrstLevelCode)) { // 如果存在二级
        const secondCommercialDatas = currentData?.children?.map(item => {
          return {
            key: item.code || '',
            label: item.name + (item.poiNum ? ' ' + item.poiNum : ''),
          };
        });
        setSecondCommercialData(secondCommercialDatas);
        setCurrentSecondCommercialIndex(secondCommercialDatas[0]?.key); // 设置二级选中的位置
        checkButtonData = currentData?.children?.[0].children;

      } else {
        checkButtonData = currentData?.children;
        setSecondCommercialData([]);
        setCurrentSecondCommercialIndex(''); // 设置二级选中的位置
      }
      const checkButtonDatas = checkButtonData?.map((item: any) => {
        return {
          value: item.code,
          label: item.name + (item.poiNum ? `(${item.poiNum})` : ''),
        };
      });
      setAgeLimitData(checkButtonDatas);

    }

  }, [currentCommercialIndex]);// 如果当前业态类型发生改变

  return (
    <div className={styles['search']}>
      <V2Tabs
        activeKey={currentCommercialIndex}
        items={commercialData}
        className={styles['tabs']}
        onChange={methods.onCommercialChange}/>
      {secondCommercialData?.length ? <ButtonTabs activeKey={currentSecondCommercialIndex} items={secondCommercialData} className={styles['button-tab']} onChange={methods.onSecondCommercialChange}/> : ''}
      {ageLimitData?.length
        ? <V2Form layout='inline' form={form}>
          <V2FormCheckbox label='经营年限' name='thirdLevelCode' options={ageLimitData} onChange={methods.onAgeLimitChange}/>
        </V2Form>
        : ''
      }
    </div>

  );
};

export default Search;
